import cx from "classnames";
import * as React from "react";

import MyRepeatLogo from "assets/images/RepeatMD_myRepeat.svg?url";

export interface PlatformLogoProps {
  logoUrl?: string | null;
  platformName?: string | null;
  className?: string;
}

export const PlatformLogo: React.FC<PlatformLogoProps> = ({
  className,
  logoUrl,
  platformName,
}) => {
  return (
    <img
      className={cx("max-h-48 w-1/3 max-w-48 object-contain", className)}
      src={logoUrl ?? MyRepeatLogo}
      alt={platformName ?? "RepeatMD"}
    />
  );
};
